import { useState } from 'react';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import SubscriptionModal from '@/components/SubscriptionModal';

type AccountPopoverProps = {
  isActive: boolean;
};

export default function AccountPopover({ isActive }: AccountPopoverProps) {
  const navigate = useNavigate();
  const { userEmail, signOut } = useAuth();
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  const handleBilling = () => {
    setSubscriptionModalOpen(true);
  };

  return (
    <Popover className="relative">
      <PopoverButton
        className={[
          'font-mono font-medium text-xs tracking-[0.6px] uppercase transition-colors outline-none cursor-pointer',
          isActive
            ? 'text-foreground underline underline-offset-8 decoration-2'
            : 'text-muted-foreground hover:text-foreground'
        ].join(' ')}
      >
        Account
      </PopoverButton>

      <PopoverPanel
        anchor="bottom end"
        className="z-50 mt-2 w-64 bg-background border border-border rounded shadow-lg"
      >
        <div className="p-4 flex flex-col gap-3">
          <div className="text-xs font-mono text-muted-foreground truncate">
            {userEmail}
          </div>

          <div className="h-px bg-border" />

          <button
            onClick={handleBilling}
            className="text-left text-sm font-mono uppercase tracking-[0.6px] text-foreground hover:text-primary transition-colors cursor-pointer"
          >
            Billing
          </button>

          <a
            href="https://mail.google.com/mail/?view=cm&to=support@byllms.com&su=WE%20HAVE%20TO%20TALK&body=Call%20me%20asap."
            target="_blank"
            rel="noopener noreferrer"
            className="text-left text-sm font-mono uppercase tracking-[0.6px] text-foreground hover:text-primary transition-colors cursor-pointer"
          >
            Contact Support
          </a>

          <button
            onClick={handleSignOut}
            className="text-left text-sm font-mono uppercase tracking-[0.6px] text-foreground hover:text-primary transition-colors cursor-pointer"
          >
            Sign out
          </button>
        </div>
      </PopoverPanel>

      <SubscriptionModal
        open={subscriptionModalOpen}
        onOpenChange={setSubscriptionModalOpen}
      />
    </Popover>
  );
}
